import { type ReactNode } from 'react'

import { findReactChildrenByDisplayName } from '@flecto/utils/src/Window/findReactChildrenByDisplayName'

export function useFilterChildren(children: ReactNode) {
  let footerChildren: ReactNode = null
  let contentChildren: ReactNode = null
  let headerChildren: ReactNode = null

  if (Array.isArray(children)) {
    headerChildren = findReactChildrenByDisplayName(children, [
      'ModalIcon',
      'ModalClose',
      'ModalTitle',
      'ModalSubtitle',
      'ModalClose',
    ])

    footerChildren = findReactChildrenByDisplayName(children, [
      'ModalCancel',
      'ModalSubmit',
      'ModalFooterExtra',
    ])

    contentChildren = findReactChildrenByDisplayName(children, 'ModalContent')
  } else {
    contentChildren = children
  }

  return { headerChildren, footerChildren, contentChildren }
}
